<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="ipadfp"><img alt="Cover: The Weight of Night, by Christine   Carbo" class="imagefp" src="image/9781501156243.jpg"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?21df3d91